// GENERATED FILE - DO NOT EDIT

// This file has been automatically generated. Any modifications made to this file will be overwritten the next time it is regenerated. Please refrain from editing this file directly.

import PhoneNumberData from '../../types/PhoneNumberData';

import { format5 } from '../../constants';

/** New Zealand */
const NZ: PhoneNumberData = [64, 'NZ', 8, format5, 10, '00 0000 0000'];

export default NZ;
